import { useCallback, useMemo, useState } from "react";

export interface AmazonHoverTrianglePoint {
  x: number;
  y: number;
}
export const useAmazonHoverTriangle = () => {
  const [points, setPoints] = useState<
    | [
        AmazonHoverTrianglePoint,
        AmazonHoverTrianglePoint,
        AmazonHoverTrianglePoint
      ]
    | null
  >(null);

  const area = useMemo(() => {
    if (!points) {
      return null;
    }
    const [a, b, c] = points;
    return calculateArea(a, b, c);
  }, [points]);

  const setTriangle = useCallback(
    (
      a: AmazonHoverTrianglePoint,
      b: AmazonHoverTrianglePoint,
      c: AmazonHoverTrianglePoint
    ) => {
      setPoints([a, b, c]);
    },
    []
  );

  const isPointInsideTriangle = useCallback(
    (point: AmazonHoverTrianglePoint): null | boolean => {
      if (!points || !area) {
        return null;
      }

      const [a, b, c] = points;
      const AreaA = calculateArea(point, a, b);
      const AreaB = calculateArea(point, b, c);
      const AreaC = calculateArea(point, a, c);

      return area >= AreaA + AreaB + AreaC;
    },
    [area, points]
  );

  return {
    points,
    setTriangle,
    isPointInsideTriangle,
  };
};

const calculateArea = (
  a: AmazonHoverTrianglePoint,
  b: AmazonHoverTrianglePoint,
  c: AmazonHoverTrianglePoint
): number => {
  const area = (a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - b.y)) / 2;
  return area < 0 ? -1 * area : area;
};
